<template>
  <div class="system-notice">
    <el-button size="small" type="primary" @click="addNotice">添加通知</el-button>

    <el-button type="small" icon="el-icon-plus" @click="actionUnfoldFunc(true)">展开</el-button>
    <el-button type="small" icon="el-icon-minus" @click="actionUnfoldFunc(false)">折叠</el-button>

    <div class="table-style">
      <el-table ref="ctab" size="mini" :data="noticeList" :header-cell-style="{ background: '#eef1f6' }">
        <el-table-column type="expand" @click="LookNotice(props.row)">
          <template slot-scope="props">
            <span v-html="props.row.content"></span>
          </template>
        </el-table-column>

        <el-table-column label="序号">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="title" label="标题"></el-table-column>
        <el-table-column label="类型">
          <template slot-scope="scope">
            <span v-if="scope.row.notice_type == '1'">弹出-仅标题</span>
            <span v-else-if="scope.row.notice_type == '2'">弹出-标题及内容</span>
            <span v-else-if="scope.row.notice_type == '3'">不弹出</span>
          </template>
        </el-table-column>

        <el-table-column label="是否公开">
          <template slot-scope="scope">
            <span v-if="scope.row.is_send_all_subject">是</span>
            <span v-else>否</span>
          </template>
        </el-table-column>
        <el-table-column label="所属科目">
          <template slot-scope="scope">
            <span v-for="item in scope.row.noticeSubjectArr" :key="item.id">{{
                item.subjectName + ','
            }}</span>
          </template>
        </el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="PreviewNotice(scope.row)">预览</el-button>
            <el-button size="mini" type="text" @click="edit_notice(scope.row)">编辑</el-button>
            <el-button size="mini" type="text" @click="adminDeleteNotice(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog :title="notice_form.title" :visible.sync="dialogVisible" width="600px">
      <div style="max-height: 300px; overflow-y: scroll" v-html="notice_form.content"></div>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="drawer = true">编辑</el-button>

        <el-button size="small" type="primary" @click="submit">确认发布</el-button>

      </span>
    </el-dialog>

    <el-drawer z-index="1000" :model="false" title="编辑通知" :visible.sync="drawer" :with-header="false" size="1300px">
      <div style="overflow: hidden; width: 1250px; margin: 0 auto; padding-top: 22px;">
        <div style="width: 600px; min-height:calc(100vh - 200px);  float: left;margin-left:20px;">
          <el-card shadow="never">
          <el-form class="form-style" ref="notice_form" :model="notice_form" :inline="true" :rules="rules" size="small">
            <el-form-item label="通知标题" required prop="title">
              <el-input placeholder="请输入通知标题" v-model="notice_form.title">
              </el-input>
            </el-form-item>

            <el-form-item label="通知类型" required prop="notice_type">
              <el-select v-model="notice_form.notice_type" placeholder="请选择">
                <el-option label="弹出-仅标题" :value="1"></el-option>
                <el-option label="弹出-标题及内容" :value="2"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="所属科目">
              <el-select multiple collapse-tags clearable v-model="notice_form.subjectIds" placeholder="请选择科目"
                :disabled="notice_form.is_open">
                <el-option :label="item.name" :value="item.id" v-for="(item, index) of subjectList"
                  :key="index"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="科目公开">
              <!-- `checked` 为 true 或 false -->
              <el-checkbox v-model="notice_form.is_open">是</el-checkbox>
            </el-form-item>
          </el-form>

          <tinymce style="margin: 20px;" v-model="notice_form.content" />
        </el-card>
        </div>
        <div style="width: 600px; float: left;margin-left:20px;">
          <el-card shadow="never">
          <div>
            标题:{{ notice_form.title }}
          </div>
          <div style="min-height: calc(100vh - 145px); overflow-y: scroll" v-html="notice_form.content"></div>
          <div style="overflow: hidden;">
            <div style="float: right; margin-right: 20px;">
            <el-button size="small" type="primary" @click="submit">确认发布</el-button>
          </div>
          </div>
        </el-card>
        </div>

      </div>


    </el-drawer>
  </div>
</template>

<script>
import {
  getStstemImagesList,
  adminAddOrUpdateNotice,
  getSubjectList,
  adminGetNoticeList,
  adminDeleteNotice,
} from "@/api/admin";
import uploadFile from "@/config/uploadFile";
import Tinymce from "@/components/Tinymce";
export default {
  name: "system-notice",
  components: {
    Tinymce,
  },
  data() {
    return {
      imageId: "",
      form: {
        title: "",
        image_link: "",
        fileList: [],
      },
      tableData: [],
      dialogVisible: false,
      rules: {
        title: [
          {
            required: true,
            message: "请输入通知标题",
            trigger: "change",
          },
          {
            required: true,
            message: "请输入通知标题",
            trigger: "blur",
          },
        ],
        notice_type: [
          {
            required: true,
            message: "请选择通知类型",
            trigger: "change",
          },
          {
            required: true,
            message: "请选择通知类型",
            trigger: "blur",
          },
        ],
      },
      uploadFileTime: false,
      notice_form: {
        title: "",
        content: "",
        notice_type: "",
        is_send_stu: "",
        is_send_all_subject: "",
        subjectIds: [],
        is_open: false,
      },

      noticeId: "", //通知id

      subjectList: [],
      noticeList: [], //系统通知列表
      drawer: false,
      isExpand: true, // 默认为展开状态
    };
  },
  computed: {},
  mounted() {
    this.getSubjectList();
    this.adminGetNoticeList();
  },
  watch: {
    "notice_form.is_open": function () {
      console.log("notice_open");
      console.log(this.notice_form.is_open);
      if (this.notice_form.is_open) {
        this.notice_form.subjectIds = [];
      }
    },
  },
  methods: {
    getSubjectList() {
      getSubjectList(
        {
          subject_state: "1",
          page_no: 1,
          page_size: 100,
        },
        true
      ).then((res) => {
        console.log("平台科目");
        console.log(res);
        this.subjectList = res.subject_list;
      });
    },

    adminAddOrUpdateNotice() {
      console.log("提交的参数");
      console.log(this.notice_form);

      if (this.noticeId) {
        adminAddOrUpdateNotice({
          noticeId: this.noticeId,
          title: this.notice_form.title,
          content: this.notice_form.content,
          notice_type: this.notice_form.notice_type,
          is_send_stu: "2",
          is_send_all_subject: this.notice_form.is_open ? "1" : "2",
          subjectIdArr: JSON.stringify(this.notice_form.subjectIds),
        }).then((res) => {
          console.log("添加通知");
          console.log(res);
          if (res.is_update) {
            this.$message.success("修改通知成功");
            this.adminGetNoticeList();
            this.drawer = false;
          }
        });
      } else {
        adminAddOrUpdateNotice({
          title: this.notice_form.title,
          content: this.notice_form.content,
          notice_type: this.notice_form.notice_type,
          is_send_stu: "2",
          is_send_all_subject: this.notice_form.is_open ? "1" : "2",
          subjectIdArr: JSON.stringify(this.notice_form.subjectIds),
        }).then((res) => {
          console.log("添加通知");
          console.log(res);
          if (res.is_create) {
            this.$message.success("发送通知成功");
            this.adminGetNoticeList();
            this.drawer = false;
          }
        });
      }
    },

    adminGetNoticeList() {
      adminGetNoticeList().then((res) => {
        console.log("系统通知");
        console.log(res);
        this.noticeList = res.noticeList;
      });
    },

    LookNotice(row) {
      console.log("查看通知");
      console.log(row);
    },

    addNotice() {
      this.noticeId = "";
      this.notice_form = {};
      // this.dialogVisible = true;
      this.drawer = true
    },
    quitDialog(formName) {
      this.$refs[formName].resetFields();
      this.dialogVisible = false;
    },

    PreviewNotice(row) {
      console.log("预览");
      console.log(row);
      this.dialogVisible = true;
    },

    submit() {
      console.log("发布通知");
      if (!this.notice_form.notice_type) {
        this.$message.warning("请选择通知类型");
        return;
      }
      if (!this.notice_form.is_open) {
        if (this.notice_form.subjectIds.length == 0) {
          this.$message.warning("请选择科目");
          return;
        }
      }

      this.adminAddOrUpdateNotice();
    },

    edit_notice(row) {
      console.log("编辑通知");
      console.log(row);
      this.noticeId = row.id;
      this.dialogVisible = true;
      this.notice_form.title = row.title;
      this.notice_form.content = row.content;
      this.notice_form.notice_type = row.notice_type;

      this.notice_form.subjectIds = [];
      if (row.noticeSubjectArr.length > 0) {
        for (let k = 0; k < row.noticeSubjectArr.length; k++) {
          this.notice_form.subjectIds.push(row.noticeSubjectArr[k].subject_id);
        }
      }
    },

    actionUnfoldFunc(isAss) {
      //this.$refs.ctab.handleExpand(isAss)
      this.handleExpand(isAss);
    },
    handleExpand(isAss) {
      // 此判断是否为展开状态或折叠状态--若展开折叠是同一个按钮则无需传参和加此if
      if (this.isExpand == isAss) {
        return;
      }
      this.isExpand = !this.isExpand;
      // this.tableData为返回的二级数据data
      this.$nextTick(() => {
        this.forArr(this.noticeList, this.isExpand);
      });
    },
    // 遍历
    forArr(arr, isExpand) {
      arr.forEach((i) => {
        // toggleRowExpansion见element文档
        this.$refs.ctab.toggleRowExpansion(i, isExpand);
        if (i.children) {
          this.forArr(i.children, isExpand);
        }
      });
    },

    uploadFile() { },
    handleRemove(file, fileList) {
      this.form.fileList = fileList;
    },
    async handleChangeFile(file, fileList) {
      if (!this.uploadFileTime) {
        await this.uploadFileOss(fileList);
      }
    },
    async uploadFileOss(list) {
      this.uploadFileTime = true;
      await uploadFile(list, this.$store.state.user.userInfo.code).then(
        (res) => {
          this.form.fileList = res;
          this.uploadFileTime = false;
        }
      );
    },
    adminDeleteNotice(row) {
      this.$confirm("确定删除该通知吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        adminDeleteNotice({
          noticeId: row.id,
        }).then(() => {
          this.$message.success("删除成功！");
          this.adminGetNoticeList();
        });
      });
    },
    getStstemImagesList() {
      getStstemImagesList({
        image_type: 1,
      }).then((res) => {
        this.tableData = res.ststem_index_images;
      });
    },
  },
};
</script>

<style scoped lang="scss">
.system-notice {
  height: 100%;
  background-color: #fff;
  padding: 15px;
  margin: 15px;

  .form-style {
    margin-left: 15px;

  }

  .table-style {
    margin-top: 15px;
  }
}
/deep/ .tox-tinymce{
  min-height: calc(100vh - 308px);
}
</style>

